module.exports = __webpack_public_path__ + "img/password-gen-details1.ae1539f6.png";